module.exports = require('./generateAppWindowHelpers')
